import React from "react";
import Logo from "../assets/logo_textoblanco_fondotransp.png";
import "../css/Header.css";
import { Link } from "react-router-dom";
import { buildWhatsAppUrl } from "../config/whatsapp";
import { useContactSettings } from "./ContactSettingsProvider";

function Header() {
  const { whatsappPhone } = useContactSettings();
  const whatsappUrl = buildWhatsAppUrl(undefined, whatsappPhone);
  return (
    <div className="header-wrapper">
      <div className="header">
        <img src={Logo} alt="Micro Cuotas" />
        <div className="barra-navegacion">
          <Link to="https://microcuotas.com.ar/">
            Inicio
          </Link>
          <Link to="https://microcuotas.com.ar/#nosotros">
            Sobre nosotros
          </Link>
          <Link to="https://microcuotas.com.ar/#contacto">
            Contacto
          </Link>
        </div>
      </div>
      <a
        className="whatsapp-banner"
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={"Gestion\u00e1 tu pr\u00e9stamo ahora mismo por WhatsApp"}
      >
        {"Gestion\u00e1 tu pr\u00e9stamo ahora mismo clickeando AQU\u00cd"}
      </a>
    </div>
  );
}

export default Header;
